export default {"src":"/_next/static/media/child-branch.b8c6a65a.svg","height":32,"width":32};